var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "unbind-page tongxin-layout"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("解除綁定確認頁")]), _c('p', {
    staticClass: "unbind-description"
  }, [_vm._v(" 請注意，解除會員綁定後，將無法使用進一步服務，原先設定的家人資料將無法再顯示。無法再收到個人化訊息通知。請問您要申請「解除綁定」嗎？ ")]), _c('div', {
    staticClass: "unbind-nav"
  }, [_c('TongxinNavigation', {
    attrs: {
      "canProceed": _vm.canProceed,
      "backButtonIsVisible": true,
      "nextButtonIsVisible": true,
      "textForNextStep": _vm.nextButtonText
    },
    on: {
      "back": _vm.handleBack,
      "next": _vm.handleNext
    }
  })], 1), _vm.isUnbinding || _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }